import React, { useState } from 'react';
import PhoneInput from 'react-phone-input-2';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import SimpleReactValidator from 'simple-react-validator';
import { setUser } from '../../redux/actions/user.actions';
import btnIcon from '../../assets/images/arrow-circle.svg';
import logo from '../../assets/images/Lovrican-Logo-Icon.svg';
import privatelock from '../../assets/images/private_lock.svg';
import { authCall } from '../../services';
import authService from '../../services/authServices';


const Step15Sub1Component = ({ step, handleNext, userDetails }) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const [validator] = useState(
    new SimpleReactValidator({
      validators: {
        phoneNumber: {
          message: 'Invalid mobile number.',
          rule: (val) => val.length < 12,
          required: true
        }
      }
    })
  );
  const [loading, setLoading] = useState(false);
  const [values, setValues] = useState({
    phoneNumber: userDetails?.phone ? userDetails?.phone : '',
    phoneHelp: false,
    linkedInURL: userDetails?.linkedin_URL ? userDetails?.linkedin_URL : '',
    linkedInHelp: false
  });

  const submitForm = async () => {
    if (validator.allValid()) {
      const formData = {
        phone: values.phoneNumber
      };

      if (userDetails.is_affiliate === 1) {
        formData.isProfileComplted = 'YES';
      }

      setLoading(true);
      const resp = await authCall('auth/register-section', formData);
      if (resp && resp.success === true) {
        dispatch(setUser(resp.data.user));
        setLoading(false);

        if (resp.data.user.is_affiliate === 1) {
          authService.throwBackRevRegister(history);
        } else {
          handleNext(step);
        }
      }
      setLoading(false);
    } else {
      validator.showMessages();
      setValues({ ...values });
    }
  };

  return (
    <>
      <section className="registerDetails section-one lattest-reg-screen">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 text-center">
              <div className="logo cursor-pointer" role="button" tabIndex="0">
                <img src={logo} className="img-fluid" alt="Lovrican Logo" />
              </div>
            </div>
            <div className="col-12 text-center">
              <div className="progress">
                <div className="progress-bar step15" />
              </div>
            </div>
          </div>

          <div className="row join-reg top-join">
            <div className="col-md-12 col-lg-12">
              <div className="subtitle">
                Provide your phone number to help verify authenticity
                on Lovrican. Your information remains confidential
              </div>
            </div>
          </div>
          <div className="row join-reg bottom-join inner_bottom">
            <div className="col-md-12 col-lg-12 pb-2 custome_select mb-3 private_wrapper">
              <div className="custom_input p-0">
                <PhoneInput
                  containerClass="custom_flag"
                  placeholder="Phone Number"
                  country="us"
                  value={values.phoneNumber}
                  onChange={(phone) =>
                    setValues({ ...values, phoneNumber: phone })
                  }
                />
                <input
                  type="text"
                  name="user-phone_number"
                  id="user-phone_number"
                  placeholder="Phone Number"
                  autoComplete="off"
                  className="custom_input d-none"
                  value={values.phoneNumber}
                  onChange={(e) =>
                    setValues({ ...values, phoneNumber: e.target.value })
                  }
                />
              </div>
              {validator.message(
                'Phone Number',
                values.phoneNumber,
                'phoneNumber|required'
              )}
              <div className="text-right">
                <div
                  className="private_btn"
                  aria-hidden="true"
                  onClick={() => {
                    setValues({
                      ...values,
                      phoneHelp: true,
                      linkedInHelp: false
                    });
                  }}
                >
                  Private
                  <img
                    src={privatelock}
                    className="lock_private"
                    alt="Lock"
                    aria-hidden="true"
                  />
                </div>
              </div>
              {values.phoneHelp && (
                <div className="toolTipHelp d-flex left">
                  <p>
                    This information is private and never shared with anyone.
                    Lovrican uses this information to ensure all members meet
                    the high standards our members expect.
                  </p>
                  <div className="ml-3">
                    <i
                      className="fa fa-times cursor-pointer"
                      aria-hidden="true"
                      onClick={() =>
                        setValues({
                          ...values,
                          phoneHelp: false
                        })
                      }
                    />
                  </div>
                </div>
              )}
            </div>

            <div className="col-md-12 col-lg-12 pb-4 mb-3 mt-3  marb7 text-right">
              <button
                className={`new_next_btn ${loading ? 'hks-btn-disable' : ''}`}
                onClick={submitForm}
                onKeyDown={(event) => event.key === 'Enter' && submitForm()}
                type="button"
                tabIndex="0"
                disabled={loading || false}
              >
                <img src={btnIcon} className="img-fluid" alt="Lovrican Logo" />
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Step15Sub1Component;
